import React from 'react';
import * as S from './MiniCard.styles';

const MiniCard = ({
  Icon,
  label,
  onClick,
  disabled,
  noWrap = false,
  testId = 'mini-card',
}) => {
  const handleClick = () => {
    if (disabled) return;
    onClick();
  };

  return (
    <S.Container
      onClick={handleClick}
      $disabled={disabled}
      data-testid={testId}
    >
      {Icon && <Icon color={disabled ? 'lowLight' : 'lowDark'} />}
      <S.Label $noWrap={noWrap}>{label}</S.Label>
    </S.Container>
  );
};

export default MiniCard;
